export default "__VITE_ASSET__DthgI5Z7__"